import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../api';
import { toast } from 'sonner';
import { ArrowRight } from 'lucide-react';

/**
 * HistorialCambios — histórico de cambios de clase del cliente, EMBEBIDO (sin modal).
 * SOLO INFORMATIVO (Ann): el cliente ve sus cambios pero NO puede cancelarlos aquí.
 * - Los cambios se realizan en el gestor de cambios pinchando en las horas.
 * - La cancelación de un cambio SOLO la hace el editor/administrador desde el CRM.
 * Fuente: GET /client/historial (cambios del propio cliente).
 */
const HistorialCambios = () => {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  // Antelación mínima para cambiar (misma config que el gestor). Se muestra AQUÍ,
  // no en el gestor (Ann): esta regla vive en el histórico dentro de "Mi actividad".
  const [limiteTexto, setLimiteTexto] = useState(null);

  useEffect(() => {
    let activo = true;
    axios.get(`${API}/client/historial`)
      .then((r) => { if (activo) setHistorial(r.data || []); })
      .catch(() => { if (activo) toast.error('Error al cargar historial'); })
      .finally(() => { if (activo) setLoading(false); });
    axios.get(`${API}/client/mi-mes`)
      .then((r) => { if (activo) setLimiteTexto(r.data?.limite_cambios_texto || null); })
      .catch(() => {});
    return () => { activo = false; };
  }, []);

  const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('es-ES', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
  const formatSimpleDate = (dateStr) => new Date(dateStr + 'T00:00:00').toLocaleDateString('es-ES', {
    day: '2-digit', month: '2-digit',
  });

  return (
    <div className="pt-3">
      {/* Regla de antelación (movida aquí desde el gestor · Ann) */}
      <div className="flex items-center gap-2 mb-3 px-3 py-2 rounded-[10px]"
           style={{ background: '#EAF3F2', border: '1px solid #D8E7E4' }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3C8696" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>
        <span className="text-[12px]" style={{ color: '#2C6675' }}>
          Puedes cambiar una clase hasta <strong>{limiteTexto || '30 minutos'} antes</strong> de que empiece.
        </span>
      </div>
      {loading ? (
        <div className="flex justify-center py-6">
          <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-teal-500"></div>
        </div>
      ) : historial.length > 0 ? (
        <div className="space-y-2.5">
          {historial.map((item) => (
            <div
              key={item.id}
              data-testid={`historial-item-${item.id}`}
              className={`p-3 rounded-lg border ${item.cancelado ? 'border-gray-200 bg-gray-50 opacity-60' : 'border-gray-200 bg-white'}`}
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 text-sm font-medium">
                  <span className={item.cancelado ? 'text-gray-400 line-through' : 'text-gray-900'}>
                    {formatSimpleDate(item.fecha_original)} {item.hora_original}
                  </span>
                  <ArrowRight className={`w-4 h-4 flex-shrink-0 ${item.cancelado ? 'text-gray-400' : 'text-teal-500'}`} />
                  <span className={item.cancelado ? 'text-gray-400 line-through' : 'text-teal-600 font-semibold'}>
                    {formatSimpleDate(item.fecha_nueva)} {item.hora_nueva}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-[11px] text-gray-500">{formatDate(item.fecha_creacion)}</span>
                  {item.cancelado && (
                    <span className="text-[11px] bg-red-100 text-red-600 px-2 py-0.5 rounded font-medium">Cancelado</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6 text-sm text-gray-500">No tienes cambios registrados</div>
      )}
    </div>
  );
};

export default HistorialCambios;
